import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "flex" }, null, -1)
const _hoisted_2 = { class: "flex" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-pdf mr-2.5 text-medium" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-xls mr-2.5 text-medium" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_outline_button = _resolveComponent("outline-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_outline_button, {
        type: "outline",
        class: "ml-2.5",
        onClick: _ctx.exportPdf
      }, {
        default: _withCtx(() => [
          _hoisted_3,
          _createTextVNode(_toDisplayString(_ctx.$t('proposal.list.content.table.body.actions.pdf')), 1)
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_outline_button, {
        type: "outline",
        class: "ml-2.5",
        onClick: _ctx.exportXls
      }, {
        default: _withCtx(() => [
          _hoisted_4,
          _createTextVNode(_toDisplayString(_ctx.$t('proposal.list.content.table.body.actions.xls')), 1)
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ], 64))
}